"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import styles from './AccentBox.module.scss.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import '../../lib/propsContext/propsContext.mjs';
import 'react';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';

const AccentBox = flowComponent("AccentBox", (props) => {
  const { color = "blue", children, elementType = "div", className } = props;
  const rootClassName = clsx(styles.accentBox, className, styles[color]);
  const Element = elementType;
  const contentColor = color === "green" ? "dark" : void 0;
  const propsContext = {
    Link: {
      color: contentColor
    },
    Text: { color: contentColor },
    Heading: { color: contentColor }
  };
  return /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children: /* @__PURE__ */ jsx(Element, { className: rootClassName, children }) });
});

export { AccentBox, AccentBox as default };
//# sourceMappingURL=AccentBox.mjs.map
